import THEME from "../../../theme";
import { fs } from "../utils/styles";

export default function OffeneAufgaben({ aufgaben, onNavigiere }) {
  if (!aufgaben || aufgaben.length === 0) {
    return (
      <div style={{ ...fs.karte, borderLeft: `3px solid ${THEME.colors.success}` }}>
        <h3 style={{ color: THEME.colors.text, marginTop: 0 }}>✓ Offene Aufgaben</h3>
        <p style={{ color: THEME.colors.textMuted, margin: 0 }}>Nichts zu erledigen.</p>
      </div>
    );
  }
  return (
    <div style={{ ...fs.karte, borderLeft: `3px solid ${THEME.colors.warning}` }}>
      <h3 style={{ color: THEME.colors.text, marginTop: 0 }}>⚠ Offene Aufgaben</h3>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {aufgaben.map(a => (
          <div key={a.typ} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderTop: `1px solid ${THEME.colors.border}` }}>
            <span style={{ color: THEME.colors.text }}>{a.titel} <strong style={{ color: THEME.colors.warning }}>({a.anzahl})</strong></span>
            <button onClick={() => onNavigiere(a.ziel_tab, a.ziel_filter)} style={{ ...fs.btnGray, width: "auto", padding: "6px 14px", fontSize: THEME.fontSize.sm }}>Jetzt bearbeiten</button>
          </div>
        ))}
      </div>
    </div>
  );
}
